import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import { loadSuccess, loadFailure, loadRequest } from './actions';

export function* loadPedidoEntrega({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}criaPedidoEntrega&token=${state.auth.token}`,
      {
        pedido: {
          chaveNfe: payload.request.pedido.chaveNfe,
          codCdd: payload.request.pedido.codCdd,
          codDestinatario: payload.request.pedido.codDestinatario,
          codFornecedor: payload.request.pedido.codFornecedor,
          codTomador: payload.request.pedido.codTomador,
          codTransportadora: payload.request.pedido.codTransportadora,
          clienteEntrega: payload.request.pedido.clienteEntrega,
          valor: payload.request.pedido.valor,
          numNota: payload.request.pedido.numNota,
          pesoBruto: payload.request.pedido.pesoBruto,
          codCidadeOrigem: payload.request.pedido.codCidadeOrigem,
          observacao: payload.request.pedido.observacao,
          tipoVolume: payload.request.pedido.tipoVolume,
          qtdVolume: payload.request.pedido.qtdVolume,
        },
        nomeArquivo: payload.request.nomeArquivo,
        chave: payload.request.chave,
      }
    );
    Swal.fire({
      title: 'Item adicionado com sucesso!',
      html: '',
      showConfirmButton: false,
      timer: 1500,
      icon: 'success',
    });
    yield put(loadSuccess(response.data.pedido));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Não foi possível criar o pedido, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
        showConfirmButton: true,
      });
    }
  }
}
